import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { NETWORK_MENUS, APP_URLS } from "../header/network-config";

/** The category order, separators and destinations come from PicPlayer. */
export function NetworkMenus(): React.JSX.Element {
  return (
    <nav className="network-menu" aria-label="Creative network" onKeyDown={(event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
      const triggers = Array.from(event.currentTarget.querySelectorAll<HTMLButtonElement>(".network-trigger"));
      const current = triggers.indexOf(event.target as HTMLButtonElement);
      if (current < 0) return;
      event.preventDefault();
      const next = event.key === "Home" ? 0 : event.key === "End" ? triggers.length - 1
        : (current + (event.key === "ArrowRight" ? 1 : -1) + triggers.length) % triggers.length;
      triggers[next]?.focus();
    }}>
      {NETWORK_MENUS.map((menu) => (
        <DropdownMenu.Root key={menu.label} modal={false}>
          <DropdownMenu.Trigger asChild>
            <button type="button" className="menu-trigger network-trigger">{menu.label}</button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content className="dropdown-content network-dropdown" align="end" sideOffset={7} collisionPadding={8}>
              {menu.groups.map((group, index) => (
                <div role="group" key={index}>
                  {index > 0 && <DropdownMenu.Separator className="dropdown-separator" />}
                  {group.map((name) => {
                    const url = APP_URLS[name];
                    const safe = Boolean(url && /^https?:\/\//.test(url));
                    return safe ? (
                      <DropdownMenu.Item key={name} asChild>
                        <a className="network-item" href={url} target="_blank" rel="noopener noreferrer"
                          aria-current={name === "ModelMotive" ? "page" : undefined}>
                          <span>{name}</span>{name === "ModelMotive" && <small>Current app</small>}
                        </a>
                      </DropdownMenu.Item>
                    ) : <DropdownMenu.Item className="network-item" disabled key={name}>{name} <small>Not configured</small></DropdownMenu.Item>;
                  })}
                </div>
              ))}
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      ))}
    </nav>
  );
}
